import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, BreadcrumbLink } from '4ff-lib-foundation/lib/AppFrame/publicAPI/components';
import { MDSBreadcrumbsLayout, MDSBreadcrumbsContainer } from './styles';

const getMDSBreadcrumbs = (children) => (
  <>
    <MDSBreadcrumbsLayout>
      <Breadcrumbs
        container={MDSBreadcrumbsContainer}
        item={BreadcrumbLink}
        finalProps={{ active: true }}
        compare={(a, b) => a.weight - b.weight}
        removeProps={{ weight: true }}
      />
    </MDSBreadcrumbsLayout>
    {children}
  </>
);

const ExternalBreadcrumbs = ({ themeName, children }) => (
  themeName === 'mds'
    ? getMDSBreadcrumbs(children)
    : children
);

ExternalBreadcrumbs.propTypes = {
  themeName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ExternalBreadcrumbs;
